import {GraphQLService} from "./graphql.service";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Voucher} from "../models/voucher.model";

import voucherQuery from 'src/app/graphql/queries/voucher.query.graphql'

@Injectable()
export class VoucherService extends GraphQLService<Voucher> {
  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar);
  }

  byCode(code: string) {
    return this.find(voucherQuery, {code})
  }

}
